import { render, staticRenderFns } from "./swiperIcons.vue?vue&type=template&id=cc27259e&scoped=true&"
import script from "./swiperIcons.vue?vue&type=script&lang=js&"
export * from "./swiperIcons.vue?vue&type=script&lang=js&"
import style0 from "./swiperIcons.vue?vue&type=style&index=0&id=cc27259e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc27259e",
  null
  
)

export default component.exports